import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadMasterFranchisees } from './actions';
import List from './List';

class Franchisees extends Component {
	constructor(props) {
		super(props);	
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadMasterFranchisees({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		return (
			<div>
				<List data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { masterFranchisees }
	} = state;

	const masterFranchiseesPagination = pagination.masterFranchisees.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: masterFranchiseesPagination.ids.map(id => masterFranchisees[id]),
		pagination: masterFranchiseesPagination
	};
};

export default connect(mapStateToProps, {
	loadMasterFranchisees
})(Franchisees);